module.exports = __webpack_public_path__ + "static/img/certnotes.c8c33e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certnotes.png
// module id = k0ub
// module chunks = 1